(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bozetto-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-brand-story')) {
    class BzBrandStory extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab.dataset.tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.querySelectorAll('[data-more]').forEach((button) => {
          button.addEventListener('click', () => this.toggleText(button));
        });

        this.onBlockSelect = (event) => {
          if (this.contains(event.target)) this.select(event.detail.blockId);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.resizeObserver = new ResizeObserver(() => this.updateCollapse());
        this.panels.forEach((panel) => this.resizeObserver.observe(panel));
        this.updateCollapse();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }

      select(id, focus = false) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active) {
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            if (focus) tab.focus({ preventScroll: true });
          }
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== id;
        });
        this.updateCollapse();
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next].dataset.tab, true);
      }

      updateCollapse() {
        if (!this.hasAttribute('data-collapsible')) return;
        this.panels.forEach((panel) => {
          const text = panel.querySelector('[data-text]');
          const button = panel.querySelector('[data-more]');
          if (!text || !button || panel.hidden) return;
          if (button.getAttribute('aria-expanded') === 'true') return;

          text.classList.add('is-collapsed');
          text.style.maxHeight = '';
          button.hidden = text.scrollHeight <= text.clientHeight + 4;
          if (button.hidden) text.classList.remove('is-collapsed');
        });
      }

      toggleText(button) {
        const text = this.querySelector(`#${button.getAttribute('aria-controls')}`);
        if (!text) return;
        const expand = button.getAttribute('aria-expanded') !== 'true';
        const label = button.querySelector('[data-more-label]');

        if (expand) {
          text.style.maxHeight = `${text.clientHeight}px`;
          text.classList.remove('is-collapsed');
          requestAnimationFrame(() => {
            text.style.maxHeight = `${text.scrollHeight}px`;
          });
          text.addEventListener('transitionend', () => {
            if (button.getAttribute('aria-expanded') === 'true') text.style.maxHeight = 'none';
          }, { once: true });
        } else {
          text.style.maxHeight = `${text.scrollHeight}px`;
          requestAnimationFrame(() => {
            text.classList.add('is-collapsed');
            text.style.maxHeight = '';
          });
        }

        button.setAttribute('aria-expanded', String(expand));
        if (label) label.textContent = expand ? this.dataset.readLess : this.dataset.readMore;
      }
    }

    customElements.define('bz-brand-story', BzBrandStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bozetto-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bz-hero-slider')) {
    class BzHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bz-hero__track');
        this.slides = Array.from(this.track.children);
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('.bz-hero__dot'));
        this.current = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.abort = new AbortController();
        const { signal } = this.abort;

        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { signal });
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('pointerenter', () => (this.paused = true), { signal });
        this.addEventListener('pointerleave', () => (this.paused = false), { signal });
        this.addEventListener('focusin', () => (this.paused = true), { signal });
        this.addEventListener('focusout', () => (this.paused = false), { signal });

        // Theme editor: show the selected slide block
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const index = this.slides.indexOf(event.target);
            if (index === -1) return;
            this.stopAutoplay();
            this.goTo(index, false);
          },
          { signal }
        );

        const delay = Number(this.dataset.autoplay);
        if (delay && !this.reducedMotion && !window.Shopify?.designMode) {
          this.timer = setInterval(() => {
            if (this.paused || document.hidden) return;
            this.goTo((this.current + 1) % this.slides.length);
          }, delay);
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.stopAutoplay();
      }

      onClick(event) {
        const dot = event.target.closest('.bz-hero__dot');
        const arrow = event.target.closest('.bz-hero__arrow');
        if (!dot && !arrow) return;

        this.stopAutoplay();
        if (dot) {
          this.goTo(Number(dot.dataset.index));
        } else {
          const count = this.slides.length;
          this.goTo((this.current + Number(arrow.dataset.direction) + count) % count);
        }
      }

      onScroll() {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index !== this.current) this.setCurrent(index);
      }

      goTo(index, smooth = true) {
        this.track.scrollTo({
          left: index * this.track.clientWidth,
          behavior: smooth && !this.reducedMotion ? 'smooth' : 'instant',
        });
        this.setCurrent(index);
      }

      setCurrent(index) {
        this.current = index;
        this.slides.forEach((slide, i) => (slide.inert = i !== index));
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }

      stopAutoplay() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('bz-hero-slider', BzHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bozetto-trust-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function starta(rot) {
      if (rot.dataset.bztReady) return;
      rot.dataset.bztReady = '1';

      var citat = rot.querySelectorAll('[data-bzt-quote]');
      if (citat.length < 2) return;

      var sekunder = parseFloat(rot.dataset.bztInterval) || 5;
      var i = 0;
      var timer = null;

      // Den som bett om mindre rörelse får läsa i egen takt
      var stilla = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (stilla) return;

      function visa(n) {
        citat[i].classList.remove('is-on');
        i = n;
        citat[i].classList.add('is-on');
      }

      function nasta() { visa((i + 1) % citat.length); }

      function kor() { timer = setInterval(nasta, sekunder * 1000); }
      function stanna() { clearInterval(timer); timer = null; }

      kor();

      // Rotera inte medan sektionen är utanför skärmen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (poster) {
          poster.forEach(function (p) {
            if (p.isIntersecting) { if (!timer) kor(); }
            else { stanna(); }
          });
        }, { threshold: 0.2 }).observe(rot);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stanna();
        else if (!timer) kor();
      });
    }

    function boot() {
      document.querySelectorAll('[data-bzt]').forEach(starta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-benefits"] && !Shopify.designMode) return;
  try {
    
  /**
   * Rotates the benefits one at a time on narrow screens.
   * Pauses while the tab is hidden and respects reduced-motion (no rotation).
   */
  class BenefitsRotator extends HTMLElement {
    #index = 0;
    #timer = null;

    connectedCallback() {
      this.items = [...this.querySelectorAll('.benefits__item')];
      if (this.items.length === 0) return;

      this.items[0].classList.add('is-active');
      if (this.items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.#start();
      document.addEventListener('visibilitychange', this.#onVisibility);
      window.addEventListener('pagehide', this.#stop, { passive: true });
    }

    disconnectedCallback() {
      this.#stop();
      document.removeEventListener('visibilitychange', this.#onVisibility);
      window.removeEventListener('pagehide', this.#stop);
    }

    get interval() {
      const seconds = parseFloat(getComputedStyle(this.parentElement).getPropertyValue('--benefits-rotate'));
      return (Number.isFinite(seconds) && seconds > 0 ? seconds : 4) * 1000;
    }

    #start = () => {
      if (this.#timer) return;
      this.#timer = setInterval(this.#next, this.interval);
    };

    #stop = () => {
      clearInterval(this.#timer);
      this.#timer = null;
    };

    #next = () => {
      this.items[this.#index].classList.remove('is-active');
      this.#index = (this.#index + 1) % this.items.length;
      this.items[this.#index].classList.add('is-active');
    };

    #onVisibility = () => {
      document.hidden ? this.#stop() : this.#start();
    };
  }

  if (!customElements.get('benefits-rotator')) {
    customElements.define('benefits-rotator', BenefitsRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
